import { render, staticRenderFns } from "./tradeCenter.vue?vue&type=template&id=5e8995cb&scoped=true&"
import script from "./tradeCenter.vue?vue&type=script&lang=js&"
export * from "./tradeCenter.vue?vue&type=script&lang=js&"
import style0 from "./tradeCenter.vue?vue&type=style&index=0&id=5e8995cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8995cb",
  null
  
)

export default component.exports